<template>
  <div ref="toggle" :class="{toggle:true,active:active}" @click="onClick()">
    <span class="cross">
      ✕
    </span>
    <span class="inner">
      {{title}}
    </span>
  </div>
</template>

<script>
export default {
  name: 'toggle',
  props: {
    title: "",
    indicatorId: "",
    toggleId: "",
    color:""
  },
  data() {
    return {
      active: false
    }
  },
  methods: {
    onClick() {
      this.active = !this.active;
      this.$emit('click', {'indicatorId': this.indicatorId, 'toggleId': this.toggleId, 'active': this.active});
    },
    clear() {
      this.active = false;
    }
  },
  mounted() {
    this.$refs.toggle.style.setProperty('--color', this.$props.color);
    this.$refs.toggle.style.setProperty('--light-color', this.$props.color+'22');
  },
  watch: { 
    color: function(newVal, oldVal) { // watch it
      this.$refs.toggle.style.setProperty('--color', newVal);
      this.$refs.toggle.style.setProperty('--light-color', newVal+'22');
    }
  }
}
</script>

<style scoped lang="scss">
  .toggle {
    font-size: 0.8rem;
    display:flex;

    .inner {
      background-color: var(--light-color); 
      flex: 1 1 auto;
      padding:1px 4px ;
      // margin-right:1rem;
      font-weight:bold;
      border-radius:3px;
      letter-spacing: 0.05em;
    }
    margin:0 0.25rem 0.25rem 0;
    padding:0.1rem 0.3rem;
    
  
    &.active,
    &:hover {
      .inner {
        background-color: var(--color);
      }
      
    }

    .cross {
      color:white;
      // border: 1px solid rgb(167, 167, 167);
      // padding:0.2rem;
      text-align: center;
      margin-right:0.25rem;
      font-weight: bold;
    }
    &.active {
      .cross {
        color:black;
      }
    }

    // &.active:hover {
    //   background-color: #ff6767;
    // }
    
    // &:hover {
    //   background-color: #ffd3d3;
    // }
    margin-right:0.5rem;
    text-transform: uppercase;
    
    cursor:pointer;

  }
</style>
